import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import Link from '../../components/link/internal-link';
import MoreButton from '../../components/more-button';
import CategoryActions from '../../containers/category-actions';
import PageCover from '../../components/page-cover';
import { MoreIcon } from '../../components/icons';
import withTranslate from '../../hoc/with-translate';
import withFontClassName from '../../hoc/with-font-class-name';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import withAuth from '../../hoc/with-auth';
import styles from './category-list-item.scss';

const COVER_WIDTH = 296;
const COVER_HEIGHT = 220;

class CategoryListItem extends Component {
  render() {
    const { category = {}, t, titleFontClassName, contentFontClassName, borderWidth, isAuthenticated } = this.props;
    const containerClassName = classNames(styles.container, 'forum-card-border-color', 'category-list-item');
    const textColor = _.get(category, 'textColor.color', '#000000');
    const titleClassName = classNames(styles.titleContainer, titleFontClassName, 'category-list-item__title');
    const style = { borderWidth, color: textColor };
    const categoryLink = `/${category.slug}`;
    let moreButton;

    if (isAuthenticated) {
      const icon = <MoreIcon fill={textColor}/>;
      moreButton = (
        <div className={styles.moreButton}>
          <MoreButton icon={icon}>
            <CategoryActions category={category}/>
          </MoreButton>
        </div>
      );
    }

    const linkClassName = classNames(
      styles.overlay,
      contentFontClassName,
      'category-list-item__link');

    return (
      <div className={containerClassName} style={style} data-hook="category-list-item">
        <PageCover
          cover={category.cover}
          coverType={category.coverType}
          overlayColor={category.overlayColor}
          backgroundColor={category.backgroundColor}
          width={COVER_WIDTH}
          height={COVER_HEIGHT}
        >
          <Link
            className={linkClassName}
            to={categoryLink}
            renderInSeo={false}
          >
            <div className={titleClassName}>
              <h2 className={styles.title}>
                <object type="communities/link">
                  <Link to={categoryLink} style={{ color: 'inherit' }}>
                    {category.label}
                  </Link>
                </object>
              </h2>
            </div>
            <p className={classNames(styles.statistics, 'category-list-item__statistics')}>
              {t('category-list-item.total-views', { count: category.totalViews || 0 })}
              {' | '}
              {t('category-list-item.total-posts', { count: category.totalPosts || 0 })}
            </p>
            <p className={styles.description}>
              {category.description}
            </p>
          </Link>
          {moreButton}
        </PageCover>
      </div>
    );
  }
}

CategoryListItem.propTypes = {
  category: PropTypes.object,
  t: PropTypes.func,
  titleFontClassName: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  borderWidth: PropTypes.number.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

export default withFontClassName(withCardBorderWidth(withTranslate(withAuth(CategoryListItem))));



// WEBPACK FOOTER //
// ./app/components/category-list-item/category-list-item.js